
import {
  HashRouter as Router,
  Route,
  Switch
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { Redirect } from "react-router-dom";

import "./styles/styles.scss";

import BigHeadLayout from "./Components/Layouts/BigHead";
import TopFanTokens from "./Components/FanTokens/TopFanTokens";
import TopNFT from "./Components/NFT/TopNFT";
import FanToken from "./Components/FanTokens/FanToken";
import NFT from "./Components/NFT/NFT";
import Attributes from "./Components/Attributes/Attributes";
import Request from "./Components/RequestNftCollection/Request";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Switch>
          <Route path={["/"]}>
            <BigHeadLayout />
            <Route exact path={"/"} render={() => <Redirect to="/nft" />} />
            <Route exact path={"/fan-token"} component={TopFanTokens}></Route>
            <Route exact path={"/fan-token/:id"} component={FanToken}></Route>
            <Route exact path={"/nft"} component={TopNFT}></Route>
            <Route exact path={"/collection/:id"} render={(props) => <NFT {...props} NftType={true} />}></Route>
            <Route exact path={"/nft/:id"} render={(props) => <NFT {...props} NftType={false} />}></Route>
            <Route exact path={"/request"} component={Request}></Route>
            <Route
              exact
              path={"/nft/attributes/:id"}
              component={Attributes}
            ></Route>
          </Route>
        </Switch>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
